import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaProdutosMaisVendidos } from '@/features/relatorio/page/venda/produtos-mais-vendidos/RelatorioVendaProdutosMaisVendidos';

export const Route = createFileRoute('/a/relatorio/venda/produtos-mais-vendidos')({
    component: RelatorioVendaProdutosMaisVendidos,
});
